import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css"; // Make sure styles are imported

const CustomPhoneInput = ({ value, onChange, onBlur }) => {
  return (
    <div className="w-full mb-2">
      <PhoneInput
        country={"us"}
        value={value}
        onChange={(phone) => onChange(`+${phone}`)}
        onBlur={onBlur} // Restore country code if deleted
        enableSearch={true} // Allow country search
        countryCodeEditable={false}
        containerClass="w-full"
        inputClass="!w-full !h-11 !p-4 !pl-12 !border !rounded"
        buttonClass="!bg-gray-200 !border-r !rounded-l"
      />
    </div>
  );
};

export default CustomPhoneInput;
